import React, {Component} from 'react';
import {Card, message, Table} from 'antd';
import moment from 'moment';

import {queryAddressBusinessList, queryAddressBusinessStatis, queryAddressLiberate} from '@api/incubator/address';
import {BackBtn} from '@comm/BackBtn';
import AddressStatic from './AddressStatic';

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statis: {},
      dataSource: {
        list: [],
        pagination: {},
      },
    };
  }

  componentDidMount() {
    this.current = 1;
    this.getAddressBusinessList();
    this.getAddressBusinessStatis();
  }

  getAddressBusinessList = () => {
    queryAddressBusinessList({
      incubatorUuid: this.props.params.uuid,
      ...this.pagination,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          dataSource: {
            list: res.data,
            pagination: {
              total: res.totalSize,
              pageSize: 15,
              current: this.current,
            },
          },
        });
      }
    });
  };

  getAddressBusinessStatis = () => {
    queryAddressBusinessStatis({
      incubatorUuid: this.props.params.uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        this.setState({
          statis: res.data,
        });
      }
    });
  };

  handleTableChange = pagination => {
    this.pagination = {
      limit: pagination.pageSize,
      start: pagination.current,
    };
    this.current = pagination.current;
    this.getAddressBusinessList();
  };

  handleLiberate = uuid => {
    queryAddressLiberate({ uuid }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.getAddressBusinessList();
        this.getAddressBusinessStatis();
      }
    });
  };

  callback = key => {};

  columns = () => {
    return [
      {
        title: '地址名称',
        dataIndex: 'addressName',
        key: 'addressName',
      },
      {
        title: '合同编号',
        dataIndex: 'businessNo',
        key: 'businessNo',
      },
      {
        title: '注册公司',
        dataIndex: 'customName',
        key: 'customName',
      },
      {
        title: '注册时间',
        key: 'beginDate',
        render: (text, record) => (
          <span>{text ? moment.unix(record.beginDate / 1000).format('YYYY-MM-DD') : ''}</span>
        ),
      },
      {
        title: '结束时间',
        key: 'endDate',
        render: (text, record) => (
          <span>{text ? moment.unix(record.endDate / 1000).format('YYYY-MM-DD') : ''}</span>
        ),
      },
      {
        title: '推荐人',
        dataIndex: 'recommend',
      },
      {
        title: '推荐人手机号',
        dataIndex: 'recommendTel',
      },
    ];
  };

  render() {
    const {
      dataSource: { list, pagination },
      statis,
    } = this.state;
    return (
      <div>
        <div style={{ marginBottom: '16px' }}>
          <BackBtn />
        </div>
        <Card title="地址使用情况">
          <AddressStatic statisData={statis} />
          <Table
            rowKey="uuid"
            style={{ background: '#fff' }}
            rowSelection={{}}
            columns={this.columns()}
            dataSource={list}
            pagination={pagination}
            onChange={this.handleTableChange}
          />
        </Card>
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/incubator/address/PageUseDetail.js